$(function() {
	var mainNavActiveArrow = $('nav.main-nav svg.arrow-down');
	function setMainNavArrow() {
		var left = $('nav.main-nav a.nav-link.active').offset().left + ($('nav.main-nav a.nav-link.active').width() / 2);
		mainNavActiveArrow.css('left', left + 'px').show();
	}

	$('nav.main-nav a.nav-link').mouseover(function() {
		mainNavActiveArrow.show();

		var left = $(this).offset().left + ($(this).width() / 2);
		mainNavActiveArrow.stop().animate({ 'left' : left + 'px' }, 300);
	});

	$('nav.main-nav').mouseleave(function() {
		if ($('nav.main-nav a.nav-link.active').length === 0) {
			mainNavActiveArrow.hide();
		}

		if ($('nav.main-nav a.nav-link.active').length > 0) {
			var left = $('nav.main-nav a.nav-link.active').offset().left + ($('nav.main-nav a.nav-link.active').width() / 2);
			mainNavActiveArrow.stop().animate({ 'left' : left + 'px' }, 300);
		}
	});
	if ($('nav.main-nav a.nav-link.active').length > 0) {
		setMainNavArrow();
	} else {
		mainNavActiveArrow.hide();
	}

	//Automatically open tab from url hash
	$('a[data-toggle=tab]').on('shown.bs.tab', function (e) {
		//refreshFilterbarTop();
	});

	//Sticky filterbar
	var filterbar = $('nav.filterbar');
	if (filterbar.length > 0) {
		var filterbarTop = filterbar.offset().top;
		var filterbarSpace = $('<div class="filterbar-space"></div>');
		$(window).scroll(function() {
			if ($(this).scrollTop() >= filterbarTop) {
				if (!filterbar.hasClass('fixed-top')) {
					filterbar.after(filterbarSpace);
					filterbar.addClass('fixed-top');
				}
			} else {
				filterbar.removeClass('fixed-top');
				filterbarSpace.remove();
			}
		});

		function refreshFilterbarTop() {
			filterbar.removeClass('fixed-top');
			filterbarSpace.remove();
			filterbarTop = filterbar.offset().top;
			$(window).trigger('scroll');
		}
	}

	// Mobile toggle search
	$('nav.top-nav button.search-toggler').click(function() {
		// Reset nav
		var timeout = 0;
		if ($('nav.top-nav div.navbar-collapse.collapse.show').length > 0 && $('nav.top-nav.mobile-search').length === 0) {
			$('nav.top-nav button.navbar-toggler').click();
			timeout = 500;
		}

		setTimeout(function() {
			$('nav.top-nav').toggleClass('mobile-search');
			$('nav.top-nav div.collapse.navbar-collapse').toggleClass('show');
		}, timeout);
	});

	// Page navbar
	if ($('nav.page-navbar').length > 0) {
		let pageNavbarOffsetTop = $('nav.page-navbar').offset().top

		$(window).resize(function () {
			if (! $('nav.page-navbar').hasClass('sticky')) {
				pageNavbarOffsetTop = $('nav.page-navbar').offset().top
			}
		})

		// Toggle sticky nav
		$(window).scroll(function() {
			if ($(window).scrollTop() >= pageNavbarOffsetTop) {
				$('nav.page-navbar').addClass('sticky')

				// Add spacer
				if ($('div.page-navbar-spacer').length === 0) {
					$('nav.page-navbar').after('<div class="page-navbar-spacer"></div>');
				}
			} else {
				$('nav.page-navbar').removeClass('sticky')

				// Remove spacer
				$('div.page-navbar-spacer').remove()
			}
		});

		// Set active item
		let linkItems = []
		$('nav.page-navbar a.nav-link').each(function () {
			linkItems.push($(this).attr('href'))
		})
		$(window).scroll(function() {
			let bottomLinkItems = linkItems.filter(item => {
				return $(item).offset().top - $('nav.page-navbar').height() <= $(window).scrollTop()
			})

			if (bottomLinkItems.length > 0) {
				$('nav.page-navbar li.nav-item.active').removeClass('active')
				$('nav.page-navbar a.nav-link[href="' + bottomLinkItems[bottomLinkItems.length - 1] + '"]').parent('li').addClass('active')
			}
		});

		// Smooth scroll
	    $('nav.page-navbar a[href^="#"]').on('click',function(e) {
	        e.preventDefault();
	        var target = this.hash;
	        var $target = $(target);

	        let position = $target.offset().top - $('nav.page-navbar').height()

	        $('html, body').stop().animate({
	        	'scrollTop': position
	        }, 900, 'swing', function () {
	        	window.location.hash = target;
	        	$('html, body').scrollTop(position)
	        });
	    });

	    // Next + prev section
	    $(document).on('click', 'nav.page-navbar .btn.next-section, nav.page-navbar .btn.prev-section', function () {
	    	let currentTarget = $('nav.page-navbar li.active a.nav-link').attr('href')
	    	let nextElement = currentTarget

	    	// Next
	    	if ($(this).hasClass('next-section')) {
	  			nextElement = $('nav.page-navbar a.nav-link[href="' + currentTarget + '"]').parent('li').next('li')
	    	}

	    	// Prev
	    	if ($(this).hasClass('prev-section')) {
	    		nextElement = $('nav.page-navbar a.nav-link[href="' + currentTarget + '"]').parent('li').prev('li')
	    	}

	    	// Scroll to next element
	    	if (nextElement.length > 0 && $(nextElement.children('a').first().attr('href')).length > 0) {
	    		let position = $(nextElement.children('a').first().attr('href')).offset().top - $('nav.page-navbar').height()

		        $('html, body').stop().animate({
		        	'scrollTop': position + 1
		        }, 900, 'swing');
	  		}
	    })
	}
});
